export default function pxToRem(value) {
	return `${value / 16}rem`;
}
